module.exports = __webpack_public_path__ + "img/item_rhodes_tip.5b6ab9d9.png";